import abortion from './abortion'

export default
{
    abortion
};
